import React, { Fragment } from "react";

const ModeratorItem = ({
  moderator,
  promoteModerator,
  demoteModerator,
  deleteModerator,
}) => {
  return (
    <Fragment>
      <div className="report-item">
        <div className="user-section-alt">
          <div className="setting-user-container">
            <div className="setting-friend-user-avi-container">
              <div
                className={`avi-color-border ${
                  moderator && moderator.role === "innovator"
                    ? "green"
                    : moderator && moderator.role === "mentor"
                    ? "red"
                    : moderator && moderator.role === "employer"
                    ? "blue"
                    : ""
                }`}
              >
                <img
                  src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${moderator.avatar}`}
                  className="friend-user-avi"
                  alt="avi"
                />
              </div>
            </div>
            <div className="friend-user-info">
              <div className="online-info">
                <ul className="user-online-items">
                  <li className="user-online-item">
                    <span
                      className={`${
                        moderator && moderator.role === "innovator"
                          ? "green"
                          : moderator && moderator.role === "mentor"
                          ? "red"
                          : moderator && moderator.role === "employer"
                          ? "blue"
                          : ""
                      } name-font`}
                    >
                      {moderator.channelid}
                    </span>
                  </li>
                  <li className="user-online-item">
                    {moderator.firstname} {moderator.lastname}
                  </li>
                  <li className="user-online-item">{moderator.jobtitle}</li>
                  <li className="user-online-item">
                    {moderator && moderator.location.state},{" "}
                    {moderator && moderator.location.country}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="setting-friends-buttons-container">
            {moderator.level === "Junior" && (
              <div className="friend-button-container">
                <button
                  onClick={() => promoteModerator(moderator.channelid)}
                  className={`setting-friend-button ${
                    moderator && moderator.role === "innovator"
                      ? "background-green"
                      : moderator && moderator.role === "mentor"
                      ? "background-red"
                      : moderator && moderator.role === "employer"
                      ? "background-blue"
                      : ""
                  }`}
                >
                  <i className="fa-solid fa-wand-magic-sparkles mx-5"></i>
                  Promote
                </button>
              </div>
            )}
            {moderator.level === "Senior" && (
              <div className="friend-button-container">
                <button
                  onClick={() => demoteModerator(moderator.channelid)}
                  className={`setting-friend-button ${
                    moderator && moderator.role === "innovator"
                      ? "background-green"
                      : moderator && moderator.role === "mentor"
                      ? "background-red"
                      : moderator && moderator.role === "employer"
                      ? "background-blue"
                      : ""
                  }`}
                >
                  <i class="fa-solid fa-arrow-down-short-wide mx-5"></i>
                  Demote
                </button>
              </div>
            )}
            <div className="friend-button-container">
              <button
                onClick={() => deleteModerator(moderator.channelid)}
                className={`setting-friend-button ${
                  moderator && moderator.role === "innovator"
                    ? "background-green"
                    : moderator && moderator.role === "mentor"
                    ? "background-red"
                    : moderator && moderator.role === "employer"
                    ? "background-blue"
                    : ""
                }`}
              >
                <i className="fa-solid fa-times mx-5"></i>
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ModeratorItem;
